module.exports = __webpack_public_path__ + "9a7ed8cba404f1176a731547b7907797.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/b_underreview.svg
// module id = 985
// module chunks = 0